
import { mapState } from 'vuex';
import Gallery from './components/Gallery.vue';

export default {
  i18nComponentKey: 'WidgetCategoryReviewsGallery.WidgetCategoryReviewsGalleryPc',
  name: 'WidgetCategoryReviewsGalleryPc',
  components: { Gallery },
  computed: {
    ...mapState('widget', ['widget']),
    galleryProps() {
      const { layout_column, column_gap, row_gap } = this.widget;
      return {
        cols: layout_column,
        gutter: column_gap,
        productImageSize: 48,
        rowGap: row_gap
      };
    }
  }
};
